export default __webpack_public_path__ + "static/media/you-takecare-of-us.51596288.webp";